import axios from 'axios';
import Currency from '../entity/currency.entity';

export default class CurrencyService {
  public static getAllCurrencies(): Promise<Currency[]> {
    return axios.get('/api/v1/currency')
      .then((response: any) => Currency.ofList(response.data))
  }
}
